import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AuditTrialDetails } from '../../../shared/models/audits/audit-trial-details';
import { FilterMenu } from '../../../shared/models/filter-menu';
import { PanelList } from '../../../shared/models/panel-list';
import { SortMenu } from '../../../shared/models/sort-menu';

@Component({
  selector: 'app-skill-audit-summary',
  templateUrl: './skill-audit-summary.component.html',
  styleUrls: ['./skill-audit-summary.component.scss']
})
export class SkillAuditSummaryComponent implements OnInit, OnChanges {
  @Input() summaryData: AuditTrialDetails[] = [];
  @Output() onItemSelected = new EventEmitter<AuditTrialDetails>();

  isSummaryLoaded: boolean = false;
  skillAuditSummaryInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableToggling: false,
    enableSelection: false,
    enablePanelCardClick: true,
    enablePanelHighLight: true
  };

  constructor() {}

  ngOnInit(): void {
    this.bindSkillAuditSummary();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['summaryData']) {
      this.bindSkillAuditSummary();
    }
  }

  bindSkillAuditSummary = () => {
    this.skillAuditSummaryInput.lists = this.summaryData;
    this.skillAuditSummaryInput.filters = this.getFiltersForSkillAuditList();
    this.skillAuditSummaryInput.sort = this.getSortFieldsForSkillAuditList();
    this.skillAuditSummaryInput.clearSelection = true;
    this.isSummaryLoaded = true;
    this.skillAuditSummaryInput = { ...this.skillAuditSummaryInput };
  };

  private getFiltersForSkillAuditList = (): FilterMenu[] => {
    return [
      { filterDisplayName: 'User', filterFieldName: 'user' },
      { filterDisplayName: 'Action', filterFieldName: 'action' }
    ];
  };

  private getSortFieldsForSkillAuditList = (): SortMenu[] => {
    return [
      { sortFieldDisplayName: 'User', sortFieldName: 'user' },
      { sortFieldDisplayName: 'Action', sortFieldName: 'action' },
      { sortFieldDisplayName: 'Timestamp', sortFieldName: 'timestamp' }
    ];
  };

  showAuditAttributeDetails = (data: any) => {
    this.onItemSelected.emit(data);
  };
}
